import prefix from 'OPENTOK/prefix';
// browser
export const SUCCESS_CHECK_BROWSER_SUPPORT = prefix('SUCCESS_CHECK_BROWSER_SUPPORT');
export const FAIL_CHECK_BROWSER_SUPPORT = prefix('FAIL_CHECK_BROWSER_SUPPORT');
export const UPDATE_SCREEN_SHARING_EXTENSION_INSTALLED = prefix('UPDATE_SCREEN_SHARING_EXTENSION_INSTALLED');
// session
export const INIT_SESSION = prefix('INIT_SESSION');
export const UPDATE_SESSION_STATUS = prefix('UPDATE_SESSION_STATUS');
// publisher
export const INIT_PUBLISHER = prefix('INIT_PUBLISHER');
export const SUCCESS_INIT_PUBLISHER = prefix('SUCCESS_INIT_PUBLISHER');
export const ERR_INIT_PUBLISHER = prefix('ERR_INIT_PUBLISHER');
export const ERR_PUBLISH_PUBLISHER = prefix('ERR_PUBLISH_PUBLISHER');
export const DESTROY_PUBLISHER = prefix('DESTROY_PUBLISHER');
export const UPDATE_PUBLISHER_AUDIO_LEVEL = prefix('UPDATE_PUBLISHER_AUDIO_LEVEL');
export const CREATE_PUBLISFER_VIDEO_ELEMENT = prefix('CREATE_PUBLISFER_VIDEO_ELEMENT');
export const UPDATE_PUBLISHER = prefix('UPDATE_PUBLISHER');
// stream
export const CREATE_STREAM = prefix('CREATE_STREAM');
export const DESTROY_STREAM = prefix('DESTROY_STREAM');
export const STREAM_PROPERTY_CHANGED = prefix('STREAM_PROPERTY_CHANGED');
// subscriber
export const INIT_SUBSCRIBER = prefix('INIT_SUBSCRIBER');
export const ERR_SUBSCRIBE = prefix('FAIL_SUBSCRIBE');
export const UPDATE_SUBSCRIBER = prefix('UPDATE_SUBSCRIBER');
export const DESTROY_SUBSCRIBER = prefix('DESTROY_SUBSCRIBER');
export const UPDATE_SUBSCRIBER_AUDIO_LEVEL = prefix('UPDATE_SUBSCRIBER_AUDIO_LEVEL');

// connection
export const CREATE_CONNECTION = prefix('CREATE_CONNECTION');
export const DESTROY_CONNECTION = prefix('DESTROY_CONNECTION');
